import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhotoEditorComponent } from './photo-editor/photo-editor.component';
import { PhotoEditorToolsBarComponent } from './photo-editor-tools-bar/photo-editor-tools-bar.component';
import { PhotoEditorCanvasComponent } from './photo-editor-canvas/photo-editor-canvas.component';
import { PhotoEditorBarComponent } from './photo-editor-bar/photo-editor-bar.component';
import { PhotoEditorToolsTextComponent } from './photo-editor-tools/photo-editor-tools-text/photo-editor-tools-text.component';
import { PhotoEditorToolsFontColorComponent } from './photo-editor-tools/photo-editor-tools-font-color/photo-editor-tools-font-color.component';
import { TranslateModule } from '@ngx-translate/core';
import { PhotoEditorToolsFontSelectComponent } from './photo-editor-tools/photo-editor-tools-font-select/photo-editor-tools-font-select.component';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    PhotoEditorComponent,
    PhotoEditorToolsBarComponent,
    PhotoEditorCanvasComponent,
    PhotoEditorBarComponent,
    PhotoEditorToolsTextComponent,
    PhotoEditorToolsFontColorComponent,
    PhotoEditorToolsFontSelectComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  exports: [
    PhotoEditorComponent,
    PhotoEditorToolsBarComponent,
    PhotoEditorCanvasComponent
  ]
})
export class PhotoEditorModule { }
